import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./index.css";
import { UserDataProvider } from "@hooks/useUserData.tsx";
import "@hooks/usePush.tsx";

createRoot(document.getElementById("root")!).render(
  <UserDataProvider>
    <App />
  </UserDataProvider>
);
